<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'LayoutBlank'
}
</script>
<style scoped>
div {
    height:100vh;
}
    </style>
